import { NgModule } from '@angular/core';

import { MenubarModule } from 'primeng/menubar';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { RippleModule } from 'primeng/ripple';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CardModule } from 'primeng/card';
import { MultiSelectModule } from 'primeng/multiselect';
import { ChipsModule } from 'primeng/chips';
import { DividerModule } from 'primeng/divider';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { AccordionModule } from 'primeng/accordion';
import { ChipModule } from 'primeng/chip';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { StepperModule } from 'primeng/stepper';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CalendarModule } from 'primeng/calendar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { TabViewModule } from 'primeng/tabview';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';

const modules = [
  MenubarModule,
  AvatarModule,
  AvatarGroupModule,
  BadgeModule,
  MenuModule,
  ButtonModule,
  RadioButtonModule,
  TableModule,
  RippleModule,
  DialogModule,
  InputTextModule,
  DropdownModule,
  CardModule,
  MultiSelectModule,
  ChipsModule,
  DividerModule,
  DynamicDialogModule,
  AccordionModule,
  ChipModule,
  ScrollPanelModule,
  StepperModule,
  InputTextareaModule,
  CalendarModule,
  BreadcrumbModule,
  SelectButtonModule,
  CheckboxModule,
  ToastModule,
  TabViewModule,
  EditorModule,
  FileUploadModule,
  AutoCompleteModule,
];

@NgModule({
  declarations: [],
  imports: modules,
  exports: modules,
})
export class PrimengModule {}
